import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';

import {setNewFenceMapCenter} from '../actions';
import Map from '../../shared/components/Map';

import {setSearchTerm} from '../../shared/geocode/geocodeActions';
import {setBounds} from '../../shared/actions';

const OrganizationMap = (props) => {
  const organizationId = props.match.params.organization_id;
  const pois = (!_.isUndefined(props.organizationPoisMap.get(organizationId))) ?
                props.organizationPoisMap.get(organizationId) : [];

  let fences = [];
  const drawPois = pois.map((poi) => poi.poi);

  for (let i = 0; i < pois.length; i += 1) {
    if (pois[i].fences.length > 0) {
      fences = [...fences, pois[i].fences[0]];
    }
  }

  return(
    <div style={{ width: '100%', height: '100%' }}>
      <Map {...props} pois={drawPois} drawOnlyTopFence={true} fences={fences} />
    </div>
  )
}

OrganizationMap.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      'organization_id': PropTypes.string,
    })
  }),
  organizationPoisMap: PropTypes.instanceOf(Immutable.Map),
}

// Map props to the store

const mapStateToProps = (state) => {
  return {
    fences: [],
    mapCenter: state.routes.pois.unsavedFence.getIn(['location']),
    mapBounds: state.common.getIn(['bounds']),
    organizationPoisMap: state.routes.organizationPois.get('organizationPoiMap'),
    geocodeResults: state.geocode.results,
    drawMode: false,
    key: 'organizationMap',
  }
}

const mapDispatchToProps = (dispatch) => ({
  centerChanged: ()=>{
    dispatch(setNewFenceMapCenter(null));
  },
  updateSearchTerm: (searchTerm)=>{
    dispatch(setSearchTerm(searchTerm));
  },
  selectNewFenceMapCenter: (location)=>{
    dispatch(setNewFenceMapCenter(location));
  },
  setMapBounds: (bounds)=>{
    dispatch(setBounds(bounds))
  }
})

const OrganizationMapContainer = connect(mapStateToProps,mapDispatchToProps)(OrganizationMap);

export default OrganizationMapContainer;


// WEBPACK FOOTER //
// ./src/organizations/components/OrganizationMap.js